export default {
  props: {
    alt: {
      type: String,
      default: 'alt'
    },
    fill: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '25'
    },
    role: {
      type: String,
      default: 'svg'
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    },
    width: {
      type: String,
      default: '25'
    }
  }
};